import styled from "styled-components"
import { Card as BaseCard } from "@engaging-tech/components"

const Card = styled(BaseCard)`
  max-width: 560px;
  width: 100%;
`

export default Card
